$(function () {

    $(document).on('click', '#store-lead', function (e) {
        e.preventDefault();
        var button = $(this);
        var url = button.data('check_url');
        var form = $(this).closest('form');
        var form_data = form.serialize();
        console.log(url);
        button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Kontroluji duplicitu leadu');
        $.ajax({
            type: 'POST', url: url, data: form_data, async: true, dataType: 'json',
            success: function (data) {
                console.log(data);
                if (data.data.found == true) {
                    bootbox.alert('Nelze založit lead z následujícího důvodu:<br>' + data.data.msg);
                } else {
                    form.submit();
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
        button.html('Uložit');
    });

    $(document).on('click', '#send-mailing', function (e) {
        e.preventDefault();
        var button = $(this);
        var form = $(this).closest('form');
        button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Odesílám');
        bootbox.confirm({
            message: 'Opravdu chcete odeslat hromadnou zprávu všem aktivním tipařům?',
            buttons: {
                confirm: {
                    label: 'Ano',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Ne',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    form.submit();
                    return true;
                } else {
                    button.html('<i class="bi bi-send fs-6 me-2"></i> Odeslat');
                }
            }
        });
    });

    function isDateValid(dateStr) {
        return !isNaN(new Date(dateStr));
    }

    function diffYears(dt2, dt1) {

        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60 * 24);
        return Math.abs(Math.round(diff / 365.25));

    }

    // Verifikace a GDPR

    $(document).on('click', '#send-verification-sms', function (e) {
        e.preventDefault();

        var form = $(this).closest('form');
        var form_data = form.serialize();

        var url = $(this).data('url');

        bootbox.confirm({
            message: 'Opravdu chcete zaslat SMS s verifikačním kódem?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-primary' },
                cancel: { label: 'Ne', className: 'btn-secondary' }
            },
            callback: function (result) {
                if (result) {
                    $('#sms_verification').addClass('hidden');
                    $('#sms_verification_loading').removeClass('hidden');
                    $.ajax({
                        type: 'POST', url: url, data: form_data, async: true, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                                $('#sms_verification_loading').addClass('hidden');
                                $('#sms_verification_code').html(data.data.content);
                            } else {
                                $('#sms_verification_loading').addClass('hidden');
                                $('#sms_verification').removeClass('hidden');
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            $('#sms_verification_loading').addClass('hidden');
                            $('#sms_verification').removeClass('hidden');
                            bootbox.alert(data);
                        }
                    });
                }
            }
        });
        return true;
    });

    var canvas = document.getElementById('gdpr_signature-pad');
    var signaturePad = null;
    if (canvas !== null) {
        signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)',
            penColor: '#2d4c82'
        });
        var output_element = $('#gdpr_signature_hash');

        signaturePad.addEventListener("endStroke", () => {
            console.log("Signature updated");
            var data = signaturePad.toDataURL("image/svg+xml");
            $('#gdpr_signature_hash').val(data);
            var date_stamp = new Date($.now());
            var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
            $('#gdpr_signature-pad_meta_date').val(
                date_stamp.getFullYear() + '-' + pad(date_stamp.getMonth() + 1) + '-' + pad(date_stamp.getDate())
                + ' ' + pad(date_stamp.getHours()) + ':' + pad(date_stamp.getMinutes()) + ':' + pad(date_stamp.getSeconds())
            );
            var result = bowser.getParser(window.navigator.userAgent);
            console.log(result.parsedResult.browser.name + " v" + result.parsedResult.browser.version + " " + result.parsedResult.os.name);
            $('#gdpr_signature-pad_meta_browser').val(result.parsedResult.browser.name + " v" + result.parsedResult.browser.version + " " + result.parsedResult.os.name);
        });

        if (output_element.val().length > 0) {
            signaturePad.fromDataURL(output_element.val());
        }

        $('#clear').on('click', function (e) {
            e.preventDefault();
            signaturePad.clear();
            $('#gdpr_signature_hash').val('');
        });
    }

    $(document).on('click', '#verify-sms', function (e) {
        e.preventDefault();
        var sms_code = $('#sms-code').val();
        if (sms_code.length !== 4) {
            $('#sms-code').focus();
            bootbox.alert('Musíte vyplnit kód ze SMS');
            return false;
        }

        var form = $(this).closest('form');
        var form_data = form.serialize();

        $('#sms_verification_code').addClass('hidden');
        $('#sms_verification_loading').removeClass('hidden');
        $.ajax({
            type: 'POST', url: $(this).data('url'), data: form_data, async: true, dataType: 'json',
            success: function (data) {
                console.log(data);
                if (data.status == 'success') {
                    $('#sms_verification_loading').addClass('hidden');
                    $('#sms_verification').html('<i class="bi bi-check2-circle text-success fs-3"></i>').removeClass('hidden');
                    $('#signature').removeClass('hidden');
                } else {
                    $('#sms_verification_loading').addClass('hidden');
                    $('#sms_verification_code').removeClass('hidden');
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                $('#sms_verification_loading').addClass('hidden');
                $('#sms_verification_code').removeClass('hidden');
                bootbox.alert(data);
            }
        });
        return true;
    });

    $(document).on('click', '#confirm-form-sign', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        if (signaturePad.isEmpty()) {
            bootbox.alert({
                message: 'Je potřeba vložit podpis abychom mohli digitálně podepsat dokument.',
                backdrop: true,
                buttons: { ok: { label: 'OK', className: 'btn-primary' } }
            });
            return false;
        }

        bootbox.confirm({
            message: 'Opravdu odeslat podepsaný dokument?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-primary' },
                cancel: { label: 'Ne', className: 'btn-secondary' }
            },
            callback: function (result) {
                if (result) {
                    // SIGNATURE SECTION
                    var data = signaturePad.toDataURL("image/svg+xml");
                    $('#gdpr_signature_hash').val(data);
                    // END OF SIGNATURE SECTION
                    form.submit();
                }
            }
        });
    });

    // contract signature

    $(document).on('click', '#send-verification-sms-contract', function (e) {
        e.preventDefault();
        var address = $('#tipster-address').val();
        var bank_number = $('#tipster-bank_number').val();
        var bank_code = $('#tipster-bank_code').val();

        if (address.length < 3) {
            $('#tipster-address').focus();
            bootbox.alert('Musíte vyplnit svoji adresu');
            return false;
        }
        if (bank_number.length < 6) {
            bootbox.alert('Musíte vyplnit číslo bankovního účtu');
            $('#tipster-bank_number').focus();
            return false;
        }
        if (bank_code.length !== 4) {
            $('#tipster-bank_code').focus();
            bootbox.alert('Vyberte správný kód banky');
            return false;
        }

        var form = $(this).closest('form');
        var form_data = form.serialize();
        $.ajax({
            type: 'POST', url: $(this).data('url'), data: form_data, async: true, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    $('#sms_verification_code').html(data.data.content);
                    $('#sms_verification').addClass('hidden');
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert(data);
            }
        });
        return true;
    });

    $('.document_zoom').on('click', function (e) {
        e.preventDefault();
        $("#previewModal").modal('show');
        $('#preview_content').html('<img src="data:image/jpeg;base64, ' + $(this).data('content') + '" class="img-thumbnail" alt="Náhled faktury" />');
    });

    // common

    function base64ToBlob(base64, type = "application/octet-stream") {
        const binStr = atob(base64);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
        }
        return new Blob([arr], { type: type });
    }

    $('.previewPdfTipster').on('click', function (e) {
        e.preventDefault();
        $('#pdf_loader').css('display', 'block');
        $('#pdf-container').html('');
        var pdfid = $(this).data('pdfid');
        var url = $(this).data('apiurl');
        $.ajax({
            type: 'GET',
            url: url + '&id=' + pdfid,
            async: true,
            contentType: "application/json; charset=UTF-8",
            dataType: 'json',
            success: function (data) {
                console.log('Download OK');
                console.log(data.fileinfo);
                var base64 = data.resultdata;
                const blob = base64ToBlob(base64, 'application/pdf');
                const url = URL.createObjectURL(blob);
                var pdfData = atob(data.resultdata);
                var arr = new Uint8Array(pdfData.length);
                for (var i = 0; i < pdfData.length; i++) {
                    arr[i] = pdfData.charCodeAt(i);
                }
                var pdfDoc = null;

                pdfjsLib.getDocument(arr).promise.then(function (pdfDoc_) {
                    pdfDoc = pdfDoc_;
                    var pageCount = pdfDoc.numPages;
                    var idCan = 1
                    for (var pageNum = 1; pageNum <= pageCount; ++pageNum) {
                        pdfDoc.getPage(pageNum).then(function (page) {
                            var canvas = document.createElement('canvas');
                            canvas.setAttribute("id", idCan);
                            //canvas.setAttribute("class", "pdf-preview-page");
                            idCan++;
                            var viewport = page.getViewport({
                                scale: 1.5
                            });
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;
                            var renderContext = {
                                canvasContext: canvas.getContext('2d'),
                                viewport: viewport
                            };
                            page.render(renderContext);

                            var pdfContainer = document.getElementById('pdf-container');
                            pdfContainer.appendChild(canvas);
                        });
                    }
                });

                $('#donwload_button').empty();
                $('#donwload_button').append('<a href="data:' + data.fileinfo.contentType + ';base64,' + btoa(pdfData) + '" download="' + data.fileinfo.fileName + '" class="btn btn-subtle-primary w-100"><i class="bi bi-download me-2"></i>Stáhnout</a>');
            },
            error: function (data) {
                console.log('Load failed');
                console.log(data);
                $('#pdfModalContent').html('Chyba stažení souboru!');
            },
            complete: function (data) {
                $('#pdf_loader').css('display', 'none');
                console.log('Completed');
            },
        });
    });
});
